// extracted by mini-css-extract-plugin
export default {"balanceCell":"eH_eI","balanceCell_close":"eH_eJ"};